import { render } from "./FormInputNumber.vue?vue&type=template&id=c6e46e00"
import script from "./FormInputNumber.vue?vue&type=script&lang=js"
export * from "./FormInputNumber.vue?vue&type=script&lang=js"

import exportComponent from "/home/xs551928/niidaphoto.com/oyadori/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__